import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
  extra?: ReactNode;
}

export default function SectionHeader({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = "查看全部",
  extra,
}: SectionHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-5 md:mb-6">
      <div>
        <div className="flex items-center gap-2.5">
          <span className="h-[2px] w-6 bg-primary-500" />
          <span className="text-[11px] tracking-[0.24em] text-accent-400 font-label uppercase">{eyebrow}</span>
        </div>
        <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-50">{title}</h2>
        {description && <p className="mt-1.5 text-sm text-foreground-500 max-w-xl">{description}</p>}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {extra}
        {moreTo && (
          <Link
            to={moreTo}
            className="inline-flex items-center gap-1 h-9 px-3.5 rounded-md border border-background-300/70 text-xs text-foreground-300 hover:border-primary-400 hover:text-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            {moreLabel}
            <i className="ri-arrow-right-line" />
          </Link>
        )}
      </div>
    </div>
  );
}